import {route} from '@/router/route-utils'

const routes = [

    route(
        '/', 'auth.login', {
            components : {
                main: () => import('./views/login/LoginView')
            },
            layout: 'LayoutBlank',
            title: 'Login'
        }
    ),

    route(
        '/register', 'auth.register', {
            components : {
                main: () => import('./views/register/RegisterView')
            },
            layout: 'LayoutBlank',
            title: 'Register'
        }
    ),

    route(
        '/pending-profile', 'auth.pending', {
            components : {
                main: () => import('./views/pending/PendingView')
            },
            layout: 'LayoutBlank',
            title: 'Pending'
        }
    ),

];

export default routes
